// frontend/packages/business-console/src/services/featuresService.js
//
// Thin wrapper over GET /api/v2/features - the read-only, client-audience list
// of this tenant's operator-controllable features and their on/off state.
// Business context comes from the x-business-id header (axios interceptor).
// There is no write path here on purpose: clients see what is on for them and
// contact UpRyzze to change it (we manage it per client in UpRyzze Tools).

import { api } from '@upryzze/services';

/**
 * @returns {Promise<Array<{
 *   key: string,
 *   label: string,
 *   description: string,
 *   enabled: boolean,
 * }>>}
 */
export async function getMyFeatures() {
  const { data } = await api.get('/v2/features');
  return Array.isArray(data?.features) ? data.features : [];
}
